import React, { FC, useCallback, useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import jwt_decode from 'jwt-decode';

import { StaffService } from 'src/services/UserServices';

import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import Page from '../../layout/Page/Page';
import Card, { CardBody } from '../../components/bootstrap/Card';
import FormGroup from '../../components/bootstrap/forms/FormGroup';
import Input from '../../components/bootstrap/forms/Input';
import Button from '../../components/bootstrap/Button';
import Logo from '../../components/Logo';
import useDarkMode from '../../hooks/useDarkMode';
import AuthContext from '../../contexts/authContext';
// import USERS, { getUserDataWithUsername } from '../../../common/data/userDummyData';
// import Spinner from '../../../components/bootstrap/Spinner';
// import Alert from '../../../components/bootstrap/Alert';
import { getStorage, setStorage } from 'src/utils/utils';
import logoimg from '../../assets/logo.png';
import showNotification from 'src/components/extras/showNotification';
// import Auth2FA from './Auth2FA';
import { PaymentServices } from 'src/services/PaymentServices';
import { NumericFormat } from 'react-number-format';
import moment from 'moment';



const OrderId = () => {
	const { i18n, t } = useTranslation();
	const { setUser } = useContext(AuthContext);
	const { darkModeStatus } = useDarkMode();
	const navigate = useNavigate();
	const handleOnClick = useCallback(() => navigate('/'), [navigate]);
	const [show2Fa, setShow2Fa] = useState(false);
	const [qrString, setQrString] = useState(null);
	const [isOpenInput2fa, setIsOpenInput2fa] = useState('');
	// const [username, setUsername] = useState();
	// const [password, setPassword] = useState();
	const [token2fa, setToken2fa] = useState();
	const [status2Fa, setStatus2Fa] = useState('');

    const [prefix, setPrefix] = useState('');
    const [showTB, setShowTB] = useState(false);
    const [dataTB, setDataTB] = useState();

    const submitPrefix = async () => {
        await PaymentServices.getOrderID(prefix).then(({ data }) => {
			
            // if(data.le)
            if(data?.length>0){
                setShowTB(true);
                setDataTB(data);

                // setDataTB(data.filter((e)=>e.mch_order_no.includes("deposit")));
            }
            
            // console.log(data);
        })
        // console.log(prefix);
    };

    const onChangePrefix = (e) => {
        setPrefix(e.target.value.toUpperCase())
        // console.log(e.target.value);
    };
    const onEnter = (e) => {
        if (e.key === 'Enter' || e.keyCode === 13) {
            submitPrefix()
        }
        // console.log(e.target.value);
    };
    const convertDate = (data) => {
		const convert = moment(data).format('DD/MM/YYYY HH:mm:ss');
		return convert;
	};

    const ccyFormat = (num) => {
		return `${typeof num === 'number' ? num?.toFixed(2) : '0.00'}`;
	};

	

	// const render2FA = () => {
	// 	return (
	// 		show2Fa && (
	// 			<Auth2FA
	// 				handleSunmit2FA={formik.handleSubmit}
	// 				setToken={setToken2fa}
	// 				token={token2fa}
	// 				QR={qrString}
	// 			/>
	// 		)
	// 	);
	// };

	const [isLoading, setIsLoading] = useState(false);

	return (
		<>
			
				<PageWrapper
					isProtected={false}
					title={'Login'}
					className={classNames({ 'bg-dark': true, 'bg-light': false })}>
					<Page className='p-0'>
						<div className='row h-100 align-items-center justify-content-center'>
							<div className='col-xl-8 col-lg-8 col-md-8 shadow-3d-container'>
								<Card className='shadow-3d-dark mt-28' data-tour='login-page'>
									<CardBody>
										<div className='text-center my-5'>
											<Link
												to='#'
												className={classNames(
													'text-decoration-none  fw-bold display-2',
													{
														'text-dark': !darkModeStatus,
														'text-light': darkModeStatus,
													},
												)}
												aria-label='Facit'>
												<img src={logoimg} width={200} />
											</Link>
										</div>
										<div
											className={classNames('rounded-3', {
												'bg-l10-dark': !darkModeStatus,
												'bg-dark': darkModeStatus,
											})}></div>

										<div className='row g-4'>
											<div className='col-12'>
												<FormGroup
													id='prefix'
													isFloating
													label={t('txt_prefix')}>
													<Input
														autoComplete='Prefix'
														value={prefix}
														onChange={onChangePrefix}
                                                        onKeyUp={onEnter}
													/>
												</FormGroup>

												
											</div>
											<div className='col-12'>
												<Button
													color='warning'
													className='w-100 py-3'
													onClick={submitPrefix}>
													{t('txt_search')}
												</Button>
											</div>
										</div>
                                        {showTB && (
                                            <div className='table-responsive'>
                                                <table
                                                    className='table table-striped'
                                                    style={{ marginTop: '1rem' }}>
                                                    <thead>
                                                        <tr>
                                                            <th scope='col' className="nowrap">{t('txt_create_at')}</th>
                                                            <th scope='col' className="nowrap">Order ID</th>
                                                            <th scope='col' className="nowrap">{t('txt_amount')}</th>
                                                            <th scope='col' className="nowrap">{t('txt_bank_name')}</th>
                                                            <th scope='col' className="nowrap">{t('txt_account_number')}</th>
                                                            <th scope='col' className="nowrap">{t('txt_user_agent')}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {dataTB?.map((item, idx) => {
											            return (
                                                        <tr key={idx}>
                                                            <th scope='row' className="nowrap">
                                                                {convertDate(item?.createdAt)}
                                                            </th>
                                                            <td className="nowrap">{item?.order_no}</td>
                                                            <td>
                                                                <NumericFormat
                                                                    // style={{
                                                                    // 	color: item?.color,
                                                                    // 	fontWeight: 'bold',
                                                                    // 	fontSize: '16px',
                                                                    // }}
                                                                    value={ccyFormat(parseFloat(item?.amount))}
                                                                    thousandSeparator
                                                                    displayType={'text'}
                                                                />
                                                            </td>
                                                            <td>{item?.repay_account_bank}</td>
                                                            <td>{item?.repay_account_number}</td>
                                                            <td>{item?.user_agent}</td>
                                                        </tr>
                                                        );
                                                    })}
                                                    </tbody>
                                                    </table>
                                            </div>
                                        )}
									</CardBody>
								</Card>
							</div>
						</div>
					</Page>
				</PageWrapper>
		</>
	);
};
OrderId.propTypes = {
	isSignUp: PropTypes.bool,
};
OrderId.defaultProps = {
	isSignUp: false,
};
export default OrderId;
